export default __webpack_public_path__ + "static/media/default.17e995c369f6cfb9261332c4ed179575.png";